import { getlocalStorageLogin } from "common/components/apiConfig";

let setCookieStorageLogin = async (obj) => {
  try {
    if (obj && obj.user?.member_permitted_methods) {
      delete obj?.user?.member_permitted_methods;
    }
    const is_expired = obj?.user?.is_expired;
    const objString = obj && JSON.stringify(obj);
    const objString1 = is_expired && JSON.stringify(is_expired);

    const encodedName = encodeURIComponent("admin");
    const encodedValue = encodeURIComponent(objString);

    let cookieString = encodedName + "=" + encodedValue;
    let cookieString1 = encodeURIComponent("is_expired") + "=" + objString1;

    const isDev = process.env.REACT_APP_IS_DEV === "true";
    cookieString += "; max-age=" + (1 * 24 * 60 * 60) / 24;
    cookieString += "; path=/";
    if (!isDev) {
      cookieString += "; Secure";
    }

    cookieString += "; SameSite=Lax";

    document.cookie = cookieString;
    document.cookie = cookieString1;
  } catch (error) {
    console.error("Error setting cookie:", error);
  }
};
export const initLoginFromQuery = () => {
  const params = new URLSearchParams(window.location.search);

  const token = params.get("token");
  const member_id = params.get("member_id");
  const member_national_id = params.get("member_national_id");
  const is_expire = params.get("is_expire");

  if (!token || !member_id) return;

  const loginObj = {
    authToken: token,
    authMemberId: member_id,
    user: {
      member_national_id: member_national_id,
    },
    is_expire: is_expire,
    startTime: new Date().toISOString(),
  };

  setCookieStorageLogin(loginObj);

  const url = new URL(window.location);
  url.searchParams.delete("token");
  url.searchParams.delete("member_id");
  window.history.replaceState({}, document.title, url.pathname);
};

export const updateCookieWithProfile = (first_name, last_name) => {
  const current = getlocalStorageLogin();
  if (!current) return;

  const updated = {
    ...current,
    user: {
      ...(current.user || {}),
      member_first_name: first_name,
      member_last_name: last_name,
    },
  };

  setCookieStorageLogin(updated);
};
